import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { i18n_router_messages } from './router/static_routes.js'

// console.log(JSON.stringify(i18n_router_messages))

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  silentTranslationWarn: true,
  messages: i18n_router_messages,
})

export default i18n
